import Vue from "vue";
import { saveAs } from "file-saver";
import { AxiosResponse } from "axios";
import { http } from "@/services/https.service";
import { SiteModel } from "@/models/site.model";
import { Equipment } from "@/models/equipment.model";
import { BalanceSheetModel } from "@/models/balanceSheet.model";
import { Settings } from "@/models/settings.model";
import { GlobalSettings } from "@/models/global.model";

/**
 * This service contain methods to generate PDF Report
 */

/**
 * Call ABACA PDF Servlet and send balance sheet
 */
export async function generatePDFReport(
  settings: Settings,
  globalSettings: GlobalSettings,
  balanceSheet: BalanceSheetModel,
  eacmEquipment: Equipment,
  optionalEacmEquipment: Equipment, /*Evolution majeure de EACM */
  earEquipment: Equipment,
  isSecurityExtractorRequired: boolean,
  optionalExtractor: Equipment,
  site: SiteModel,
  fileName: string
): Promise<void> {
  const data = {
    settings: settings,
    globalSettings: globalSettings,
    balanceSheet: balanceSheet,
    eacmEquipment: eacmEquipment,
    optionalEacmEquipment: optionalEacmEquipment, /*Evolution majeure de EACM */
    earEquipment: earEquipment,
    site: site,
    isSecurityExtractorRequired: isSecurityExtractorRequired,
    optionalExtractor: optionalExtractor,
    fileName: fileName,
  };
  // send built data in order to download pdf with equipments datas
  return http
    .post(Vue.prototype.URL_GetPDF, data, { responseType: "blob" })
    .then((response: AxiosResponse) => {
      const blob = new Blob([response.data], { type: "application/pdf" });
      saveAs(blob, fileName);
    })
}
